import { TextInput, SwitchInput } from 'components/forms/Inputs';
import React from 'react';
import SubEventMapField, { SubEventMapEvent } from './SubEventMapField';

const SubEventForm = ({
  includeMap = false,
  event
}: {
  includeMap?: boolean;
  event?: SubEventMapEvent;
}) => {
  return (
    <React.Fragment>
      <TextInput required fullWidth label="Sub event" name="name" autoFocus />
      <TextInput fullWidth label="Abbreviation" name="sub" />
      <SwitchInput sx={{ width: '100%' }} name="useGPS" label="useGPS" />
      <SwitchInput sx={{ width: '100%' }} name="public" label="Public" />
      {includeMap && <SubEventMapField event={event} />}
    </React.Fragment>
  );
};

export default SubEventForm;
